import API from 'services/api'
export default class Groups extends API {
	async getGroups({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		role,
	}) {
		onStart()
		try {
			const options = {
				url:
					role === 'admin' || role === 'accountant'
						? `/admin/group/`
						: role === 'teacher'
						? `/teacher/groups/`
						: `/student/groups/`,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async getGroupById({
		id,
		role,
		month = '',
		year = '',
		filter,
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
	}) {
		onStart()
		try {
			const options = {
				url:
					role === 'admin' || role === 'accountant'
						? `/admin/group/${id}
						${month ? `/?month=${month}` : ''}
						${year ? `&year=${year}` : ''}
						${filter ? `&sort=${filter?.sort_field}&lesson=${filter?.lesson_id}` : ''}`
						: role === 'teacher'
						? `/teacher/groups/${id}
						${month ? `/?month=${month}` : ''}
						${year ? `&year=${year}` : ''}
						${filter ? `&sort=${filter?.sort_field}&lesson=${filter?.lesson_id}` : ''}`
						: `/student/groups/${id}
						${month ? `/?month=${month}` : ''}
						${year ? `&year=${year}` : ''}
						`,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async createGroups({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		data,
	}) {
		onStart()
		try {
			const options = {
				method: 'POST',
				url: `/admin/group/`,
				data,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async putPayment({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		data,
		id,
	}) {
		onStart()
		try {
			const options = {
				method: 'PUT',
				url: `/admin/student-payment/${id}/`,
				data,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async deletePayment({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		id,
	}) {
		onStart()
		try {
			const options = {
				method: 'DELETE',
				url: `/admin/student-payment/${id}/`,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async patchGrade({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		data,
		id,
	}) {
		onStart()
		try {
			const options = {
				method: 'PUT',
				url: `/teacher/grade/${id}/`,
				data,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async createGradeWithBulk({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		data,
	}) {
		onStart()
		try {
			const options = {
				method: 'POST',
				url: `/teacher/grade/bulk_create/`,
				data,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async createGrade({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		data,
	}) {
		onStart()
		try {
			const options = {
				method: 'POST',
				url: `/teacher/grade/`,
				data,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async createLessons({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		data,
	}) {
		onStart()
		try {
			const options = {
				method: 'POST',
				url: `/teacher/lessons/`,
				data,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async deleteLessons({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		id,
	}) {
		onStart()
		try {
			const options = {
				method: 'DELETE',
				url: `/teacher/lessons/${id}/`,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async patchStudents({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		data,
		id,
	}) {
		onStart()
		try {
			const options = {
				method: 'PATCH',
				url: `/admin/group/${id}/`,
				data,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async updateGroups({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		data,
	}) {
		onStart()
		const { id } = data
		try {
			const options = {
				method: 'PUT',
				url: `/admin/group/${id}/`,
				data,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async deleteGroups({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		id,
	}) {
		onStart()
		try {
			const options = {
				method: 'DELETE',
				url: `/admin/group/${id}/`,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async paymentStudent({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		data,
	}) {
		onStart()
		try {
			const options = {
				method: 'POST',
				url: `/admin/student-payment/`,
				data,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
}
